import { render, staticRenderFns } from "./Informes.vue?vue&type=template&id=68972e25&"
import script from "./Informes.vue?vue&type=script&lang=ts&"
export * from "./Informes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports